import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'sym-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  // apiEndpoint = environment.api.quicksight_cmis;
  imageSrc = '../assets/logos/letha.PNG';
  constructor() { }

  ngOnInit(): void {
  }

}
